// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
// Batch message status.
export var BatchStatus;
(function (BatchStatus) {
    BatchStatus["BATCH_STATUS_UNSPECIFIED"] = "BATCH_STATUS_UNSPECIFIED";
    BatchStatus["SCHEDULED"] = "SCHEDULED";
    BatchStatus["PROCESSING"] = "PROCESSING";
    BatchStatus["COMPLETED"] = "COMPLETED";
    BatchStatus["CANCELED"] = "CANCELED";
    BatchStatus["DELETED"] = "DELETED";
    BatchStatus["DRAFT"] = "DRAFT";
})(BatchStatus || (BatchStatus = {}));
export var BatchStatus_index;
(function (BatchStatus_index) {
    BatchStatus_index[BatchStatus_index["BATCH_STATUS_UNSPECIFIED"] = 0] = "BATCH_STATUS_UNSPECIFIED";
    BatchStatus_index[BatchStatus_index["SCHEDULED"] = 1] = "SCHEDULED";
    BatchStatus_index[BatchStatus_index["PROCESSING"] = 2] = "PROCESSING";
    BatchStatus_index[BatchStatus_index["COMPLETED"] = 3] = "COMPLETED";
    BatchStatus_index[BatchStatus_index["CANCELED"] = 4] = "CANCELED";
    BatchStatus_index[BatchStatus_index["DELETED"] = 5] = "DELETED";
    BatchStatus_index[BatchStatus_index["DRAFT"] = 6] = "DRAFT";
})(BatchStatus_index || (BatchStatus_index = {}));
// 10 DCL compliance status.
export var TenDLCComplianceStatus;
(function (TenDLCComplianceStatus) {
    TenDLCComplianceStatus["TEN_DLC_COMPLIANCE_STATUS_UNSPECIFIED"] = "TEN_DLC_COMPLIANCE_STATUS_UNSPECIFIED";
    TenDLCComplianceStatus["REGISTERED"] = "REGISTERED";
    TenDLCComplianceStatus["UNREGISTERED"] = "UNREGISTERED";
})(TenDLCComplianceStatus || (TenDLCComplianceStatus = {}));
export var TenDLCComplianceStatus_index;
(function (TenDLCComplianceStatus_index) {
    TenDLCComplianceStatus_index[TenDLCComplianceStatus_index["TEN_DLC_COMPLIANCE_STATUS_UNSPECIFIED"] = 0] = "TEN_DLC_COMPLIANCE_STATUS_UNSPECIFIED";
    TenDLCComplianceStatus_index[TenDLCComplianceStatus_index["REGISTERED"] = 1] = "REGISTERED";
    TenDLCComplianceStatus_index[TenDLCComplianceStatus_index["UNREGISTERED"] = 2] = "UNREGISTERED";
})(TenDLCComplianceStatus_index || (TenDLCComplianceStatus_index = {}));
// Sort direction for batch messages.
export var Direction;
(function (Direction) {
    Direction["DIRECTION_UNSPECIFIED"] = "DIRECTION_UNSPECIFIED";
    Direction["ASCENDING"] = "ASCENDING";
    Direction["DESCENDING"] = "DESCENDING";
})(Direction || (Direction = {}));
export var Direction_index;
(function (Direction_index) {
    Direction_index[Direction_index["DIRECTION_UNSPECIFIED"] = 0] = "DIRECTION_UNSPECIFIED";
    Direction_index[Direction_index["ASCENDING"] = 1] = "ASCENDING";
    Direction_index[Direction_index["DESCENDING"] = 2] = "DESCENDING";
})(Direction_index || (Direction_index = {}));
// The 2 different types of engagement for batch messaging.
export var Engagement;
(function (Engagement) {
    Engagement["ENGAGEMENT_UNSPECIFIED"] = "ENGAGEMENT_UNSPECIFIED";
    Engagement["ENGAGED"] = "ENGAGED";
    Engagement["UNSUBSCRIBED"] = "UNSUBSCRIBED";
})(Engagement || (Engagement = {}));
export var Engagement_index;
(function (Engagement_index) {
    Engagement_index[Engagement_index["ENGAGEMENT_UNSPECIFIED"] = 0] = "ENGAGEMENT_UNSPECIFIED";
    Engagement_index[Engagement_index["ENGAGED"] = 1] = "ENGAGED";
    Engagement_index[Engagement_index["UNSUBSCRIBED"] = 2] = "UNSUBSCRIBED";
})(Engagement_index || (Engagement_index = {}));
export var GetMessagesRequest_Category;
(function (GetMessagesRequest_Category) {
    GetMessagesRequest_Category["CATEGORY_ALL"] = "CATEGORY_ALL";
    GetMessagesRequest_Category["CATEGORY_DELIVERED"] = "CATEGORY_DELIVERED";
    GetMessagesRequest_Category["CATEGORY_FAILED"] = "CATEGORY_FAILED";
    GetMessagesRequest_Category["CATEGORY_ENGAGED"] = "CATEGORY_ENGAGED";
    GetMessagesRequest_Category["CATEGORY_UNSUBSCRIBED"] = "CATEGORY_UNSUBSCRIBED";
})(GetMessagesRequest_Category || (GetMessagesRequest_Category = {}));
export var GetMessagesRequest_Category_index;
(function (GetMessagesRequest_Category_index) {
    GetMessagesRequest_Category_index[GetMessagesRequest_Category_index["CATEGORY_ALL"] = 0] = "CATEGORY_ALL";
    GetMessagesRequest_Category_index[GetMessagesRequest_Category_index["CATEGORY_DELIVERED"] = 1] = "CATEGORY_DELIVERED";
    GetMessagesRequest_Category_index[GetMessagesRequest_Category_index["CATEGORY_FAILED"] = 2] = "CATEGORY_FAILED";
    GetMessagesRequest_Category_index[GetMessagesRequest_Category_index["CATEGORY_ENGAGED"] = 3] = "CATEGORY_ENGAGED";
    GetMessagesRequest_Category_index[GetMessagesRequest_Category_index["CATEGORY_UNSUBSCRIBED"] = 4] = "CATEGORY_UNSUBSCRIBED";
})(GetMessagesRequest_Category_index || (GetMessagesRequest_Category_index = {}));
export const BulkMessageService = {
    // CreateBatch creates a new batch of batch messages. This will create a batch message, schedule/send messages, and
    // create a template.
    CreateBatch(fn, req) {
        return fn(`/messaging/bulk/batch/v1/batches`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // UpdateBatch updates batch messages.
    // Before the original start send date passes user can update any field.
    // After the original start send date passes user can only update the title.
    // If the user would like to change more than the title after the original start send date passes
    // then their options would be to cancel or delete the batch.
    UpdateBatch(fn, req) {
        try {
            fm.validateUrlParam(req["batchId"], "batchId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/batch/v1/batches/${req["batchId"]}`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    // CancelBatches cancels batch messages. This can be done both before and after the sending starts.
    CancelBatch(fn, req) {
        try {
            fm.validateUrlParam(req["batchId"], "batchId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/batch/v1/batches/${req["batchId"]}/cancel`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    // DeleteBatches deletes batch messages. This is only a soft delete. If there are batch messages that are not yet sent
    // then those messages get canceled. Deleted batch messages should not be sent in GetBatches.
    DeleteBatch(fn, req) {
        try {
            fm.validateUrlParam(req["batchId"], "batchId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/batch/v1/batches/${req["batchId"]}?${fm.renderURLSearchParams(req, ["batchId"])}`, { method: "DELETE" });
    },
    // GetBatch gets a single batch.
    GetBatch(fn, req) {
        try {
            fm.validateUrlParam(req["batchId"], "batchId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/batch/v1/batches/${req["batchId"]}?${fm.renderURLSearchParams(req, ["batchId"])}`, { method: "GET" });
    },
    // GetBatches gets a list of batches. The result will be split up by month provided in the date range.
    // Batches are not limited to batches in the past. You will get information for all batches that have
    // been scheduled for the year. Even if that is a couple months in the future.
    GetBatches(fn, req) {
        return fn(`/messaging/bulk/batch/v1/batches?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // GetMessages returns all messages associated with a batch.
    GetMessages(fn, req) {
        try {
            fm.validateUrlParam(req["batchId"], "batchId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/batch/v1/batches/${req["batchId"]}/messages?${fm.renderURLSearchParams(req, ["batchId"])}`, { method: "GET" });
    },
    // UpdateQuota is an endpoint for Salesforce to hit and tell us when a location's quota has been updated.
    // It is required for Salesforce to send an shared password (token), effective date, slug or a location id, and new quota
    // amount. Due to the difference in auth of this endpoint and the shared token to verify that Salesforce is the
    // caller, this endpoint will be limited to HTTP calls with that defined token.
    // Either a location id or a slug is required in request.
    UpdateQuota(fn, req) {
        return fn(`/messaging/bulk/batch/v1/quota`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // GetActiveYears will return all the years that a location has been active with bulk texting.
    // As well as the current and next year in the future. For example, it is 2026.
    // If a location had bulk messages in 2023, 2024, and 2026 then
    // the years returned would be 2023, 2024, 2026, and 2027.
    GetActiveYears(fn, req) {
        return fn(`/messaging/bulk/batch/v1/years?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // CreateContactList creates a list of contacts for bulk messaging that are treated as recipients.
    // Required fields are: Title, location id, weave user id, and at least 1 contact.
    // Contacts need to have a: first name, last name, and phone number.
    CreateContactList(fn, req) {
        return fn(`/messaging/bulk/batch/v1/lists`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // UpdateContactList updates a list of contacts for bulk messaging.
    // The title or contacts can be updated.
    UpdateContactList(fn, req) {
        try {
            fm.validateUrlParam(req["listId"], "listId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/batch/v1/lists/${req["listId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // DeleteContactList will hard delete the list and the contacts associated with the list.
    DeleteContactList(fn, req) {
        try {
            fm.validateUrlParam(req["listId"], "listId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/batch/v1/lists/${req["listId"]}?${fm.renderURLSearchParams(req, ["listId"])}`, { method: "DELETE" });
    },
    // GetContactList retrieves the list information and the contacts associated with the list.
    GetContactList(fn, req) {
        try {
            fm.validateUrlParam(req["listId"], "listId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/bulk/batch/v1/lists/${req["listId"]}?${fm.renderURLSearchParams(req, ["listId"])}`, { method: "GET" });
    },
    // GetContactLists returns a list of all the contact lists for a location.
    // The response to this endpoint will only contain the contact count, not every contact.
    // If all contacts are needed, then call the GetContactList endpoint.
    GetContactLists(fn, req) {
        return fn(`/messaging/bulk/batch/v1/lists?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
